import { createContext, ReactNode, useContext, useState } from 'react';

type AuditLogSidebarContextType = {
  isAuditLogSidebarVisible: boolean;
  setIsAuditLogSidebarVisible: (visible: boolean) => void;
  toggleAuditLogSidebar: () => void;
};

const AuditLogSidebarContext = createContext<AuditLogSidebarContextType>({
  isAuditLogSidebarVisible: false,
  setIsAuditLogSidebarVisible: () => {},
  toggleAuditLogSidebar: () => {},
});

export function AuditLogSidebarProvider({ children }: { children: ReactNode }) {
  const [isAuditLogSidebarVisible, setIsAuditLogSidebarVisible] = useState(false);

  const toggleAuditLogSidebar = () => {
    setIsAuditLogSidebarVisible(!isAuditLogSidebarVisible);
  };

  return (
    <AuditLogSidebarContext.Provider
      value={{
        isAuditLogSidebarVisible,
        setIsAuditLogSidebarVisible,
        toggleAuditLogSidebar,
      }}
    >
      {children}
    </AuditLogSidebarContext.Provider>
  );
}

export const useAuditLogSidebar = () => {
  const context = useContext(AuditLogSidebarContext);
  if (!context) {
    throw new Error('useAuditLogSidebar must be used within an AuditLogSidebarProvider');
  }
  return context;
};
